"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUPPORTED_IMAGE_FORMATS = exports.MAX_FILE_SIZE_20_MB = void 0;
var SUPPORTED_IMAGE_FORMATS = exports.SUPPORTED_IMAGE_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];
var MAX_FILE_SIZE_20_MB = exports.MAX_FILE_SIZE_20_MB = 20971520;